(() => {
    const serviceCardButton = document.querySelectorAll('.service-card-title');

    serviceCardButton.forEach(button => {
        const serviceCardDropdown = button.nextElementSibling;
        button.addEventListener('click', e => {
            e.preventDefault();
            if (serviceCardDropdown.style.maxHeight) {
                serviceCardDropdown.style.maxHeight = null;
                button.setAttribute('aria-expanded', 'false');
            } else {
                serviceCardDropdown.style.maxHeight =
                    serviceCardDropdown.scrollHeight + 'px';
                button.setAttribute('aria-expanded', 'true');
            }
        });
    });

    const contentWrapper = document.getElementById('translation-pairings');

    if(contentWrapper) {
        if(contentWrapper.clientHeight >= 950) {

            contentWrapper.classList.add('hidden-content-fade');

            const seeAll = document.getElementById('see-all');

            seeAll.style.display = 'inline-block';

            seeAll.addEventListener('click', function(e) {
                e.preventDefault();
                contentWrapper.style.height = 'initial';

                this.style.display = 'none';

                contentWrapper.classList.remove('hidden-content-fade');
            } );
        }
    }
})();
